/**
 * TankManufacturer Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

const state = {
    page: {},
    tank_manufacturer: null,
    tank_manufacturers: JSON.parse(localStorage.getItem("tank_manufacturers")) || null,
    tank_manufacturers_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
    tank_manufacturers_spec: null,
    tank_manufacturers_specs: JSON.parse(localStorage.getItem("tank_manufacturers_specs")) || null,
    tank_manufacturers_specs_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchTankManufacturer({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitTankManufacturer", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitTankManufacturer", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateTankManufacturer", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitTankManufacturer(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateTankManufacturer(state, payload) {
        if (payload.method == "post" && payload.with) {
            // allows to find path with depth
            let property = _.get(state, payload.property);
            // if property is null, create new array
            if (!property) {
                _.set(state, payload.property, []);
                property = _.get(state, payload.property);
            }
            Vue.set(property, (property || []).length, payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_id = payload.id ? payload.id : payload.with[payload.pk];
            let property = _.get(state, payload.property);
            let curr_item = property[property.findIndex((obj) => obj[payload.pk] == curr_id)];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            let property = _.get(state, payload.property);
            property.splice(
                property.findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
            _.set(state, payload.property, property.length ? property : null);
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
